export enum SupplierInviteScreenStatus {
  Form = 'Form',
  Loading = 'Loading',
  UploadedCSV = 'UploadedCSV',
}
